import React,{useState} from 'react';
export default function ReceiptLink({href,children,...props}) {
  const [error,setError]=useState('');const [busy,setBusy]=useState(false);
  const filename=decodeURIComponent((href||'').split('/').pop()||'');
  if(!filename.startsWith('receipt_'))return <a href={href} {...props}>{children}</a>;
  async function download(event){event.preventDefault();if(busy)return;setBusy(true);setError('');try{
    const token=localStorage.getItem('mkb_token');
    const response=await fetch(`/api/v1/receipts/${encodeURIComponent(filename)}`,{headers:{Authorization:`Bearer ${token}`}});
    if(!response.ok)throw new Error('دریافت فیش ممکن نشد؛ دسترسی و ورود به حساب را بررسی کنید.');
    const blob=await response.blob();const url=URL.createObjectURL(blob);const anchor=document.createElement('a');anchor.href=url;anchor.download='receipt.jpg';anchor.click();setTimeout(()=>URL.revokeObjectURL(url),1000);
  }catch(failure){setError(failure.message);}finally{setBusy(false);}}
  return <><a {...props} href={`/api/v1/receipts/${encodeURIComponent(filename)}`} onClick={download} aria-busy={busy}>{children}</a>{error&&<span role="alert">{error}</span>}</>;
}
